module.exports = __webpack_public_path__ + "assets/img/flag-task-other.c8051849.svg";